import Wix from '../services/wix-sdk-polyfill';
import { MODAL_TYPE_PROFILE_ACTIONS, MODAL_TYPE_PROFILE_ACTIONS_UPPER_PART } from '../constants/modal-types';
import { getConfig } from '../services/config';
import { isInEditor } from './view-mode';

export const COMMUNITIES_POPUP_SHOW = 'COMMUNITIES_POPUP_SHOW';
export const COMMUNITIES_POPUP_HIDE = 'COMMUNITIES_POPUP_HIDE';
export const COMMUNITIES_POPUP_TOGGLED = 'COMMUNITIES_POPUP_TOGGLED';
export const COMMUNITIES_POPUP_LOADED = 'COMMUNITIES_POPUP_LOADED';
export const COMMUNITIES_POPUP_BUTTON_CLICKED = 'COMMUNITIES_POPUP_BUTTON_CLICKED';

const openPopup = (data, position) => {
  const { protocol, host } = window.location;
  const url = `${protocol}//${host}/modal`;
  Wix.openPopup(
    `${url}?data=${data}&section-url=${getConfig().sectionUrl}`,
    '1000%',
    0,
    position,
    () => {},
    Wix.Theme.BARE
  );
};

const initPopupLowerPart = () => {
  const position = {
    origin: Wix.WindowOrigin.ABSOLUTE,
    placement: Wix.WindowPlacement.BOTTOM_LEFT,
    x: 0,
    y: 0,
  };

  const data = JSON.stringify({ type: MODAL_TYPE_PROFILE_ACTIONS, props: {} });
  openPopup(data, position);
};

const initPopupUpperPart = () => {
  const position = {
    origin: Wix.WindowOrigin.ABSOLUTE,
    placement: Wix.WindowPlacement.TOP_LEFT,
    x: 0,
    y: 0,
  };

  const data = JSON.stringify({ type: MODAL_TYPE_PROFILE_ACTIONS_UPPER_PART, props: {} });
  openPopup(data, position);
};

export function initPopup() {
  if (isInEditor()) {
    return;
  }
  initPopupUpperPart();
  initPopupLowerPart();
}

export function showPopup(rect) {
  Wix.getBoundingRectAndOffsets(data => {
    Wix.PubSub.publish(COMMUNITIES_POPUP_SHOW, { x: data.offsets.x + rect.left + rect.width / 2, y: rect.bottom });
  });
}

export function hidePopup() {
  Wix.PubSub.publish(COMMUNITIES_POPUP_HIDE);
}

export function popupLoaded() {
  Wix.PubSub.publish(COMMUNITIES_POPUP_LOADED);
}

export function popupToggled() {
  Wix.PubSub.publish(COMMUNITIES_POPUP_TOGGLED);
}

export function sendButtonClicked({ type }) {
  Wix.PubSub.publish(COMMUNITIES_POPUP_BUTTON_CLICKED, { type });
}



// WEBPACK FOOTER //
// ./app/services/widget-popup.js